import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { api } from '../../api/client';
export default function InputsStep({ onAdvance, onChanged }) {
    const [items, setItems] = useState([]);
    const [urls, setUrls] = useState('');
    const [busy, setBusy] = useState(false);
    const [dragOver, setDragOver] = useState(false);
    const [error, setError] = useState(null);
    const fileInput = useRef(null);
    async function refresh() {
        setError(null);
        try {
            const r = await api.wizardInputsList();
            setItems(r.items);
            setUrls(r.urls.join('\n'));
            onChanged();
        }
        catch (e) {
            setError(e?.message ?? 'Failed to load');
        }
    }
    useEffect(() => { refresh(); }, []);
    async function uploadFiles(files) {
        setBusy(true);
        setError(null);
        try {
            for (const f of Array.from(files))
                await api.wizardInputsUpload(f);
            await refresh();
        }
        catch (e) {
            setError(e?.message ?? 'Upload failed');
        }
        finally {
            setBusy(false);
        }
    }
    async function deleteOne(name) {
        if (!window.confirm(`Remove ${name}?`))
            return;
        try {
            await api.wizardInputsDelete(name);
            await refresh();
        }
        catch (e) {
            setError(e?.message ?? 'Delete failed');
        }
    }
    async function saveUrls() {
        setBusy(true);
        setError(null);
        try {
            const list = urls.split('\n').map((u) => u.trim()).filter(Boolean);
            await api.wizardInputsUrls(list);
            await refresh();
        }
        catch (e) {
            setError(e?.message ?? 'Failed');
        }
        finally {
            setBusy(false);
        }
    }
    function onDrop(e) {
        e.preventDefault();
        setDragOver(false);
        if (e.dataTransfer?.files?.length)
            uploadFiles(e.dataTransfer.files);
    }
    function onPick(e) {
        if (e.target.files?.length)
            uploadFiles(e.target.files);
        e.target.value = '';
    }
    return (_jsxs("div", { className: "step-content", children: [_jsxs("section", { className: "card-section", children: [_jsx("h2", { children: "Files" }), _jsx("p", { className: "muted small", children: "PDF, DOCX, Markdown, or plain text. The ingest step will read these to build the brand knowledge base." }), _jsxs("div", { className: `drop-zone${dragOver ? ' drag-over' : ''}`, onDragOver: (e) => { e.preventDefault(); setDragOver(true); }, onDragLeave: () => setDragOver(false), onDrop: onDrop, onClick: () => fileInput.current?.click(), children: [_jsx("strong", { children: "Drop files here" }), _jsx("span", { className: "muted small", children: "or click to choose" })] }), _jsx("input", { ref: fileInput, type: "file", multiple: true, accept: ".pdf,.docx,.md,.txt", style: { display: 'none' }, onChange: onPick }), items.length > 0 && (_jsx("ul", { className: "input-list", children: items.map((it) => (_jsxs("li", { children: [_jsx("span", { className: "input-name", children: it.filename }), _jsxs("span", { className: "muted small", children: [(it.bytes / 1024).toFixed(0), " KB \u00B7 .", it.ext] }), _jsx("button", { className: "ghost small danger", onClick: () => deleteOne(it.filename), children: "Remove" })] }, it.filename))) }))] }), _jsxs("section", { className: "card-section", children: [_jsx("h2", { children: "URLs" }), _jsx("p", { className: "muted small", children: "One URL per line. The ingest step will fetch these server-side and feed them into the brand synthesis." }), _jsx("textarea", { className: "mono", rows: 5, value: urls, onChange: (e) => setUrls(e.target.value), placeholder: "https://example.com/about\\nhttps://example.com/services" }), _jsx("div", { className: "step-foot", children: _jsx("button", { className: "ghost", onClick: saveUrls, disabled: busy, children: busy ? 'Saving…' : 'Save URLs' }) })] }), error && _jsx("div", { className: "err small pad-y", children: error }), _jsx("div", { className: "step-foot", children: _jsx("button", { onClick: onAdvance, disabled: busy, children: "Continue \u2192" }) })] }));
}
